import React, {Component} from "react";
import Xhr from "../../helpers/Xhr";
import SportIcon from "../SportIcon";
import Sport from "./Sport";
import Loading from "../Loading";
import * as lodash from "lodash";
import Favorite from "../Favorite";
import {connect} from "react-redux";
import ACTIONS from "../../constants/actions";
import {Link} from "react-router-dom";
import {getLive} from "../../redux/actions/live";

class LiveWidget extends Component {
	state = {
		data     : {
			events  : [],
			factors : [],
			leagues : [],
			results : [],
			sports  : [],
		},
		fetching : true
	};

	componentWillMount() {
		if ( !this.props.live.isAlreadyLoaded ) {
			this.props.onGetLive();
		}

		Xhr.getLiveMenu().then((resp) => {
			this.setState({
				data     : resp.data,
				fetching : false
			});
		});
	}

	render() {
		const {events, sports} = this.state.data;
		const allEventsId = this.props.live.events.map((event) => event.id);
		const sortedSports = lodash.sortBy(sports, s => s.name);

		const data = (
			<ul className="top-event-list">
				{this.state.fetching && <Loading/>}

				{sortedSports.map((sport) =>
					<Sport key={sport.id}
					       sport={sport}
					       events={events.filter((event) => {return event.sport_id === sport.id})}/>
				)}
			</ul>
		);

		return (
			<div className="favorite-live">
				<div className="favorite-live__header">
					<span className="dot red"></span>&nbsp;
					<span>Live</span>
				</div>
				<div className="favorite-live__subheader">
					<div className="favorite-filter">
						<Favorite isFavoriteLink={true}/>
						<Link to={`/favourites/${this.props.favorites.join('-')}`}
						      className="favorite-filter__favorites">Избранное</Link>

						<Link to={`/live/${allEventsId.join('-')}`} className="show-all">Показать всё</Link>
					</div>
				</div>

				<div className="favorite-live__content">
					{data}
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		live      : state.live,
		favorites : state.favorites
	}),
	dispatch => ({
		onGetLive : () => {
			dispatch(getLive());
		}
	})
)(LiveWidget);


// WEBPACK FOOTER //
// ./src/app/components/LiveWidget/LiveWidget.js